import type { AboutDetail } from "src/types";
export const DEFAULT_ABOUT_DETAILS: AboutDetail[] = [
  {
    paragraphHeading: "A packed schedule",
    paragraph:
      "Get ready for three days of disruptive ideas and ground-breaking insights - we’re really proud of the speakers, panels and activities we’ve put together.",
  },
  {
    paragraphHeading: "Living it your way",
    paragraph:
      "With multiple thematic tracks you can pick and choose what sessions you want to join and create your own schedule.",
  },
  {
    paragraphHeading: "Not just watching",
    paragraph:
      "Live Q&As, in-session chat, polls, games, whiteboard and branistorming sessions... thought this was going to be only about watching people talk? Think again.",
  },
  {
    paragraphHeading: "Food for thought",
    paragraph:
      "We carefully selected our speakers with the goal of bringing really though-provoking, disruptive ideas to the table.",
  },
  {
    paragraphHeading: "Meaningful connections",
    paragraph:
      "Be ready to meet other brilliant minds, exchange ideas, network and lay the foundations for new, fruitful partnerships thanks to our Networking area.",
  },
  {
    paragraphHeading: "Extra content and recordings",
    paragraph:
      "You’ll have access to all recordings after the event is over, so you can go back an rewatch the sessions you didn’t catch live. We’ll also share slides and more extras.",
  },
];
